import React from "react";

import Panel from "ui/Panel";

import { Data } from "ui/Graph/util";
import { useDateRange } from "providers/WithDateRange";

import { useNetworkQuery } from "./gql/Query.generated";
import GraphSection from "ui/Graph/GraphSection";
import DateRangeGraph from "ui/Graph/DateRangeGraph";

type Props = {
  serverId: string;
};

const Network: React.FunctionComponent<Props> = ({ serverId }) => {
  const { from, to } = useDateRange();

  const { data, loading, error } = useNetworkQuery({
    variables: {
      serverId,
      startTs: from.unix(),
      endTs: to.unix(),
    },
  });

  const noData = !loading && !error && data.getSystemStats == null;

  return (
    <Panel title="Network Throughput">
      <GraphSection noData={noData} loading={loading} error={error}>
        <DateRangeGraph
          data={data?.getSystemStats as unknown as Data}
          axes={{
            left: {
              format: "bytes/sec",
            },
          }}
          series={[
            {
              key: "networkReceive",
              label: "Receive Throughput",
              tipLabel: "Rx",
            },
            {
              key: "networkTransmit",
              label: "Transmit Throughput",
              tipLabel: "Tx",
            },
          ]}
        />
      </GraphSection>
    </Panel>
  );
};

export default Network;
